import Icon from '../components/Icon.vue'

Icon.register({"magic":{"width":1664,"height":1792,"paths":[{"d":"M1190 581l293-293-107-107-293 293zM1637 288q0 27-18 45l-1286 1286q-18 18-45 18t-45-18l-198-198q-18-18-18-45t18-45l1286-1286q18-18 45-18t45 18l198 198q18 18 18 45zM286 98l98 30-98 30-30 98-30-98-98-30 98-30 30-98zM636 260l196 60-196 60-60 196-60-196-196-60 196-60 60-196zM1566 738l98 30-98 30-30 98-30-98-98-30 98-30 30-98zM926 98l98 30-98 30-30 98-30-98-98-30 98-30 30-98z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/magic.js
// module id = 1548
// module chunks = 0